import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/components/AuthProvider";

export default function Home() {
  const { user, hydrated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!hydrated) return;
    if (user) {
      navigate("/console", { replace: true });
    } else {
      navigate("/signin", { replace: true });
    }
  }, [hydrated, user, navigate]);

  return null;
}
